module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/invoice-cc754d39d071e58402ca1fba25ccc2e8.svg";